module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a1e61e4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview/src/components/checkbox/checkbox-group.vue
// module id = 1720
// module chunks = 8